import { red, success } from '@/theme/colors'
import styled from 'styled-components'
import { Pill } from '@components/Pill'

/** Connected reads as success, anything else as the warm pending tint. */
export const Badge = styled(Pill).attrs<{ $connected: boolean }>(({ $connected }) => ({
	$tone: $connected ? ('success' as const) : ('soft' as const),
}))<{ $connected: boolean }>``

export const Dot = styled.span<{ $connected: boolean }>`
	width: 6px;
	height: 6px;
	border-radius: 50%;
	flex-shrink: 0;
	background: ${({ $connected }) => ($connected ? success : red)};
`
